import Datepicker from 'rctui/Datepicker';
import React from 'react'
import I18n from 'jsx!Component/I18n'

let DateTimePicker = React.createClass({
  displayName: 'DateTimePicker',

  presets: {
    today: 0,
    day3: -3,
    week: -7,
    month: -30,
  },

  getInitialState: function () {
    let x = new Date();
    // offset in ms, <0 for gmt+3
    this.utcOffset = x.getTimezoneOffset() * 60000;
    return {};
  },

  getDefaultProps: function () {
    return {
      disabled: false,
      showPresets: false,
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string
  },

  setPreset: function (preset, e) {
    e.preventDefault();
    let value = Date.now() + this.presets[preset] * 86400000
    this.props.onChange(this.props.name, value);
  },

  timeToVal: function (value) {
    let outValue = value;
    if (outValue === undefined || outValue == null) {
      outValue = '';
    }

    return outValue;
  },

  onChange: function (value) {
    let outValue = this.timeToVal(value);

    if (outValue !== '' && outValue !== 0) {
      // component displays in local time
      outValue = value - this.utcOffset;
    }

    this.props.onChange(this.props.name, outValue);
  },
  render: function () {
    let presets = [];
    if (this.props.showPresets) {
      for (let preset in this.presets) {
        presets.push(<a href="#" onClick={this.setPreset.bind(this, preset)} key={preset}><I18n
          message={"preset." + preset}/></a>);
      }
    }

    let value = this.timeToVal(this.props.value);
    if (value !== '' && value !== 0) {
      // component displays in local time
      value = this.props.value + this.utcOffset;
    }

    return (
      <div>
        <Datepicker onChange={this.onChange} unixtime value={value}/>
        <div className="presets">
          {presets}
        </div>
      </div>
    );
  }
});

export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/js/Component/DateTimePicker.jsx